<main class="mention-panel" *ngIf="visible">
  <ul class="list" *ngIf="mode === 'users'; else channelList">
    <li class="item" *ngFor="let u of users" (click)="onPickUser(u); onUserSelected(u)">
      <article class="avatar-wrap">
        <img class="avatar" [src]="u.avatar" [alt]="u.name" />
        <span class="status" [class.online]="u.online"></span>
      </article>

      <span class="name">
        {{ u.name | slice:0:16 }}<ng-container *ngIf="u.name.length > 16">…</ng-container>
        <span *ngIf="u.uid === currentUserId" class="you">(Du)</span>
      </span>
    </li>
  </ul>

  <ng-template #channelList>
    <ul class="list">
      <li class="item" *ngFor="let c of channelsView" (click)="onPickChannel(c)">
        <div class="hash">#</div>
        <span class="name">
          {{ c.name | slice:0:16 }}<ng-container *ngIf="c.name.length > 16">…</ng-container>
        </span>
      </li>
    </ul>
  </ng-template>
</main>
